<template>
    <v-container fluid>
        <v-row justify="center" align="center" class="mt-15">
            <v-col justify="center" align="center" cols=5 md=5 lg=5 xs=12 sm=12 >
                <v-img
                    class="white--text align-end paron-logo"
                    height="auto"
                    :src="getImage()"
                />
            </v-col>
            <v-divider
                class="d-none d-lg-flex"
                vertical
                light
                inset
            ></v-divider>
            <v-col justify="center" align="center" cols=5 md=5 lg=5 sm=12 xs=12>
                <v-icon
                    :x-large=true
                    medium
                    color="#ad282d"
                >
                    mdi-tag
                </v-icon>
            </v-col>
        </v-row>
        <v-row justify="center" align="center" class="mt-15">
            <v-col justify="center" align="center" cols=12 md=12 lg=12 sm=12 xs=12>
                Δείτε εδώ όλες τις προσφορές!
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" justify="center" align="center">
                <v-card class="filter-card">
                        <v-card-text> 
                            <offers-filters @fetchData="fetchFilteredData"/> 
                        </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <div 
            v-for="(type,index) in types" 
            :key="index"
        >
            <offer :type="type" :offers="offers"/>
        </div>
    </v-container>
</template>


<script>
  import restApi from "@/rest-api"
  import Offer from '../components/Offer.vue'
  import OffersFilters from '@/components/OffersFilters.vue'

  export default {
    components: { Offer, OffersFilters },
    data() {
        return {
            types:[],
            offers: []
        }
    },
    created() {
        this.fetchTypes();
    },
    methods: {
      fetchTypes() {
        var search = `/offer/types`;
        restApi
        .get(search)
        .then(response => {
              this.types = response.map(type => type.type);
        })
        .catch((error) => {
            console.log(error);
        });
      },
      getImage() {
        return require('@/assets/LOGOPARON 2023.png')
        
      },
      fetchFilteredData(filters) {
            var search = `/offer/filtered`
            restApi
            .post(search, filters)
            .then(response => {
                this.offers = response.data
            })
            .catch((error) => {
                console.log(error);
            });

        },
    }
  }
</script>

<style lang="scss" scoped>

.filter-card{
        background-color: white; 
        color:white; 
        height:auto;
}

@media only screen and (max-width: 600px){ 
    .filter-card{
        width: 90vw;
    }

    .paron-logo{
        width: 30vw;
    }
}

@media only screen and (min-width: 600px){ 
    .filter-card{
        width: 50vw;
    }

    .paron-logo{
        width: 10vw;
    }
}

</style>